<p-toast baseZIndex="5000" key="contacto"></p-toast>
<p-confirmDialog
  header="{{ 'ayuda.contacto.titulo' | translate }}"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text p-button-secondary p-button-sm"
  acceptButtonStyleClass="p-button-sm"
>
</p-confirmDialog>

<div
  class="modal fade"
  bsModal
  #contacto_modal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left text-primary">
          {{ "ayuda.contacto.titulo" | translate }}
        </h5>
        <button
          (click)="contacto_modal.hide()"
          class="close pull-right"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <form #contactForm="ngForm">
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center small text-muted"
            >
              <span [innerHTML]="'ayuda.contacto.subtitulo' | translate"></span>
            </div>
            <div
              class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top small text-muted"
            >
              {{'forms.fields' | translate }}
            </div>
            <ng-container *ngIf="anonUser">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
                {{ "ayuda.contacto.nombre" | translate }} *
                <input
                  pInputText
                  type="text"
                  name="nombre"
                  #nombre="ngModel"
                  [(ngModel)]="template.nombre"
                  style="width: 100%"
                  required
                />
                <div *ngIf="nombre.invalid && (nombre.dirty || nombre.touched)">
                  <small *ngIf="nombre.errors.required" class="p-error">{{
                    "forms.required" | translate
                  }}</small>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
                RUT *
                <small>({{ "forms.ejemplo" | translate }}: 12.345.678-9)</small>
                <input
                  pInputText
                  type="text"
                  name="rut"
                  #rut="ngModel"
                  [(ngModel)]="template.rut"
                  style="width: 100%"
                  validateRut
                  formatRut
                  required
                />
                <div *ngIf="rut.invalid && (rut.dirty || rut.touched)">
                  <small
                    *ngIf="rut.errors.invalidRut || rut.errors.required"
                    class="p-error"
                    >{{ "forms.invalid" | translate }}</small
                  >
                </div>
              </div>
            </ng-container>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
              {{ "ayuda.contacto.correo" | translate }} *
              <input
                pInputText
                type="email"
                name="correo"
                #correo="ngModel"
                [(ngModel)]="template.correoUV"
                style="width: 100%"
                required
                email
              />
              <div *ngIf="correo.invalid && (correo.dirty || correo.touched)">
                <small *ngIf="correo.errors.required" class="p-error">{{
                  "forms.required" | translate
                }}</small>
                <small *ngIf="correo.errors.email" class="p-error">{{
                  "forms.invalid" | translate
                }}</small>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top">
              {{ "ayuda.contacto.mensaje" | translate }} *
              <textarea
                pInputTextarea
                style="width: 100%; resize: none"
                name="body"
                rows="6"
                #body="ngModel"
                [(ngModel)]="template.body"
                required
              ></textarea>
              <div *ngIf="body.invalid && (body.dirty || body.touched)">
                <small *ngIf="body.errors.required" class="p-error">{{
                  "forms.required" | translate
                }}</small>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <p-button
          label="{{ 'button.cerrar' | translate }}"
          icon="pi pi-times"
          styleClass="p-button-sm p-button-secondary p-button-text"
          (click)="contacto_modal.hide()"
        ></p-button>
        <p-button
          label="{{ 'button.enviar' | translate }}"
          icon="pi pi-check"
          styleClass="p-button-sm"
          (click)="contactForm.valid && on_send_contacto()"
          [disabled]="!contactForm.valid"
        ></p-button>
      </div>
    </div>
  </div>
</div>
